import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { HomePage } from './pages/HomePage';
import { ModelsPage } from './pages/ModelsPage';
import { Mythos4TwoPage } from './pages/Mythos4TwoPage';
import { DealerNetworkPage } from './pages/DealerNetworkPage';
import { RobetaDifferencePage } from './pages/RobetaDifferencePage';
import { AboutPage } from './pages/AboutPage';
import { MomentsOnTheMapPage } from './pages/MomentsOnTheMapPage';
import { ToolsPage } from './pages/ToolsPage';
import { ContactPage } from './pages/ContactPage';
import { BlogPage } from './pages/BlogPage';
import { BlogPostPage } from './pages/BlogPostPage';
import { SilentTravelPage } from './pages/pillars/SilentTravelPage';
import { AirFurniturePage } from './pages/pillars/AirFurniturePage';
import { PremiumInteriorsPage } from './pages/pillars/PremiumInteriorsPage';
import { CustomizationPage } from './pages/pillars/CustomizationPage';
import { CraftsmanshipPage } from './pages/pillars/CraftsmanshipPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen bg-white font-sans text-robeta-black selection:bg-robeta-copper selection:text-white" data-id="element-2">
        <Header data-id="element-3" />
        <Routes data-id="element-4">
          <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
          <Route path="/models" element={<ModelsPage data-id="element-8" />} data-id="element-7" />
          <Route path="/models/mythos4two" element={<Mythos4TwoPage data-id="element-10" />} data-id="element-9" />
          <Route path="/dealer-network" element={<DealerNetworkPage data-id="element-12" />} data-id="element-11" />
          <Route path="/about-robeta" element={<AboutPage data-id="element-14" />} data-id="element-13" />
          <Route path="/moments-on-the-map" element={<MomentsOnTheMapPage data-id="element-16" />} data-id="element-15" />
          <Route path="/tools" element={<ToolsPage data-id="element-18" />} data-id="element-17" />
          <Route path="/contact" element={<ContactPage data-id="element-20" />} data-id="element-19" />
          <Route path="/blog" element={<BlogPage data-id="element-22" />} data-id="element-21" />
          <Route path="/blog/:slug" element={<BlogPostPage data-id="element-24" />} data-id="element-23" />
          <Route path="/robeta-difference" element={<RobetaDifferencePage data-id="element-26" />} data-id="element-25" />
          <Route path="/robeta-difference/silent-travel" element={<SilentTravelPage data-id="element-28" />} data-id="element-27" />
          <Route path="/robeta-difference/air-furniture" element={<AirFurniturePage data-id="element-30" />} data-id="element-29" />
          <Route path="/robeta-difference/premium-interiors" element={<PremiumInteriorsPage data-id="element-32" />} data-id="element-31" />
          <Route path="/robeta-difference/customization" element={<CustomizationPage data-id="element-34" />} data-id="element-33" />
          <Route path="/robeta-difference/signature-craftsmanship" element={<CraftsmanshipPage data-id="element-36" />} data-id="element-35" />
        </Routes>
        <Footer data-id="element-37" />
      </div>
    </BrowserRouter>;
}